import { TooltipArrowPosition } from './../../../core/enums/TooltipArrowPosition';
import { Component, OnDestroy, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { TooltipService } from 'src/app/core/services/tooltip.service';
import { Subscription } from 'rxjs';
import { TooltipData } from 'src/app/core/models/TooltipData';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit, OnDestroy {

  @Input() content: TooltipData;

  mascot: string;
  icon: string;
  message: string;
  button: string;
  arrowPosition: string;

  tooltipArrowPos = TooltipArrowPosition;
  displayTooltip: boolean;
  tooltipDisplaySub$: Subscription;
  tooltipDataSub$: Subscription;

  constructor(
    private tooltipService: TooltipService,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (this.content) {
      this.mascot = this.content.mascot;
      this.icon = this.content.icon;
      this.message = this.content.message;
      this.button = this.content.button;
      this.arrowPosition = this.content.arrowPosition;
      this.displayTooltip = true;
      return;
    }

    this.tooltipDisplaySub$ = this.tooltipService.showTooltip$.subscribe(val => {
      this.displayTooltip = val;
      if (val) {
        document.body.style.overflowY = "hidden";
      } else {
        document.body.style.overflowY = "scroll";
      }
    });

    this.tooltipDataSub$ = this.tooltipService.tooltipData$.subscribe(data => {
      if (data) {
        this.mascot = data.mascot;
        this.icon = data.icon;
        this.message = data.message;
        this.button = data.button ? data.button : null;
        this.arrowPosition = data.arrowPosition;
      }

      this.cdRef.detectChanges();
    });
  }

  ngOnDestroy() {
    this.tooltipDisplaySub$?.unsubscribe();
    this.tooltipDataSub$?.unsubscribe();
    if (!this.content) {
      document.body.style.overflowY = "scroll";
    }
  }

  closeTooltip() {
    if (this.content) {
      this.displayTooltip = false;
      return;
    }
    this.tooltipService.close();
  }

}
